import { render, staticRenderFns } from "./DefaultMailEditInput.vue?vue&type=template&id=c1a26c4e&lang=pug&"
import script from "./DefaultMailEditInput.vue?vue&type=script&lang=ts&"
export * from "./DefaultMailEditInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports